export default {"src":"/_next/static/media/message-us-pinky-promise.9ea531d4.svg","height":136,"width":152,"blurWidth":0,"blurHeight":0};